/**
 * The browser's "remember this device" tokens for two-step verification
 * (api services/mfaTrust). One per person who signed in here and ticked the
 * box; the server decides whether any still holds. Kept across sign-out on
 * purpose: signing out ends the session, not the device's standing.
 */
const KEY = 'mm-mfa-trust';

export function readTrust() {
  try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.filter((t) => typeof t === 'string') : []; }
  catch { return []; }
}

export function saveTrust(token) {
  if (!token) return;
  try {
    const next = [token, ...readTrust().filter((t) => t !== token)].slice(0, 5);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* storage refused: the next sign-in asks for the code */ }
}

/** localStorage.clear() for sign-out, keeping this device's trust. */
export function clearSessionStorage() {
  const keep = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
  try { localStorage.clear(); if (keep) localStorage.setItem(KEY, keep); } catch { /* nothing to clear */ }
}
